const Form102PICSEN = {
    picsTitle:
        "Personal Information Collection Statement for Collecting Personal Data of Applicants",
    subtitleList: [
        { text: "Purpose of Collection" },
        { text: "Classes of Transferees" },
        { text: "Access to Personal Data" },
    ],
    symbolStep: [
        { step: "(a)" },
        { step: "(b)" },
        { step: "(c)" },
        { step: "(d)" },
        { step: "(e)" },
        { step: "(f)" },
        { step: "(g)" },
    ],
    firstStep: [
        {
            text: "The personal data provided by you in this form will be used by the EDB for one or more of the following purposes:",
        },
        {
            text: "The provision of personal data required by this form and during the processing of this form is obligatory.  In the event that you do not provide those personal data, we may not be able to handle or further process the application.",
        },
        {
            text: "The personal data you provide will be made available to persons working in EDB. Apart from this, they may be transferred or disclosed to the parties or in the circumstances listed below:-",
        },
        {
            text: `You have the right to request access to and correction of your personal data held by EDB.  Request for access or correction of personal data should be made in writing to –
            <p>&nbsp;</p>
            <p>Senior Education Officer (School Registration and Compliance)</p>
            <p>School Registration and Compliance Section</p>
            <p>Education Bureau</p>
            <p>28/F, E-Trade Plaza, 24 Lee Chung Street, Chai Wan, Hong Kong</p>
            <p>Tel. No.: 2186 6420</p>`,
        },
    ],
    secondStep: [
        {
            text: "Activities relating to the processing, authentication and counter-checking of the application for exemption from registration of schools;",
        },
        {
            text: "Activities relating to matching of the personal data with the database of other relevant Government bureaux / departments in connection with the processing, authentication and counter-checking of the application mentioned in (a) above;",
        },
        {
            text: "Activities relating to matching of the personal data within the database of EDB for purposes of verifying / updating records of the EDB;",
        },
        {
            text: "Activities relating to training and development including invitation of participation in programmes/activities, applications for reimbursement of course fees, assessment of nominations, awards and scholarship, and monitoring of attainment progress;",
        },
        {
            text: "Activities relating to the processing and vetting of applications for, and disbursement of, funding / grants / subsidies, and conducting of audits;",
        },
        {
            text: "Activities relating to compilation of statistics, research and Government publications; and",
        },
        {
            text: "Activities relating to the administration and enforcement of rules and regulations including the Education Ordinance (Cap. 279), its subsidiary legislation (such as the Education Regulations and the Grant/Subsidized Schools Provident Fund Rules) and the Codes of Aid.",
        },
    ],
    thirdStep: [
        {
            text: "other Government bureaux and departments, including Fire Services Department, Buildings Department, and Department of Justice, for the purposes mentioned in paragraph 1 above;",
        },
        {
            text: "the school in which the form relates for the purposes mentioned in paragraph 1 above;",
        },
        {
            text: "where you have given your prescribed consent to such disclosure; and",
        },
        {
            text: "where such disclosure is authorised or required under the law or court order applicable to Hong Kong.",
        },
    ],
};
export default Form102PICSEN;
